<template>
  <transition name="modal-fade" v-if="visible">
    <section
      class="modal-backdrop"
      tabindex="0"
      ref="modal"
      @click.self="hideModal"
      aria-hidden="true"
    >
      <section ref="modal" class="modal" role="dialog" :aria-labelledby="title">
        <header>
          <h5>
            {{ title }}
          </h5>
        </header>
        <article class="body">
          <component :is="component" v-bind="modalProps" />
        </article>
      </section>
    </section>
  </transition>
</template>

<script>
import '@/components/modal/subviews/index'
import { mapState, mapMutations } from 'vuex'
import { hideModal } from '@/store'

export default {
  name: 'Modal',
  data() {
    return {
      component: null
    }
  },
  computed: {
    ...mapState({
      visible: 'modalVisible',
      modalComponent: 'modalComponent',
      title: 'modalTitle',
      modalProps: 'modalProps'
    })
  },
  methods: {
    ...mapMutations([hideModal])
  },
  watch: {
    modalComponent(componentName) {
      this.component = componentName
    }
  }
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.modal {
  background: #ffffff;
  overflow-x: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.25);
  border-radius: 0.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 17.5rem;
  height: fit-content;
  box-sizing: border-box;
  justify-content: center;
  min-width: 670px;
  z-index: 101;
}
hr {
  width: 100%;
  border: none;
  border-bottom: 0.5px solid var(--hr-gray);
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
header {
  padding: 1.25rem 2.5rem 0;
  text-align: center;
}
article {
  min-height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.65rem 1.65rem;
}
</style>
